import { Directive } from '@angular/core';
import { BrnAccordionHeader } from '@spartan-ng/brain/accordion';
import { classes } from '@spartan-ng/helm/utils';

/**
 * Required around every trigger: BrnAccordionTrigger validates at runtime that
 * its parent is a heading and throws in dev mode otherwise. role/aria-level are
 * set here so consumers cannot forget them.
 */
@Directive({
  selector: '[hlmAccordionHeader],hlm-accordion-header',
  hostDirectives: [BrnAccordionHeader],
  host: {
    'data-slot': 'accordion-header',
    role: 'heading',
    'aria-level': '3',
  },
})
export class HlmAccordionHeader {
  constructor() {
    classes(() => 'flex');
  }
}
